import { StorageSubscriptionManager } from "../subscriptions";
export class EnterpriseRepository {
    subscriptionMgr = new StorageSubscriptionManager();
}
//# sourceMappingURL=EnterpriseRepository.js.map